module.exports = __webpack_public_path__ + "static/media/note6.7447c6cb.wav";